import { CalculationPoint, MechanicalAxisAP, MechanicalAxisFemurAP, MechanicalAxisFemurLT, MechanicalAxisLT, MechanicalAxisTibiaAP, MechanicalAxisTibiaLT, Save, SelectedApexMech, ToolToSave, ToolType } from "@ortho-next/nextray-core";
import { Vector3 } from "three";

/**
 * Reference point used to sync osteotomies.
 */
export class ReferencePoint extends CalculationPoint implements ToolToSave {
    public toolType = ToolType.referencePoint;
    @Save() public declare position: Vector3; // override

    constructor() {
        super("Reference point");
        this.visible = false;
    }

    /**
     * Gets position according to selected apex and mechanical axis points.
     */
    public calculate(selectedApex: SelectedApexMech, mechanicalAxis: MechanicalAxisAP | MechanicalAxisLT) {
        switch (selectedApex) {
            case SelectedApexMech.femurProximal:
            case SelectedApexMech.femurDistal:
                return this.handleFemurApex(mechanicalAxis.femur!);
            case SelectedApexMech.tibiaProximal:
            case SelectedApexMech.tibiaDistal:
                return this.handleTibiaApex(mechanicalAxis.tibia!);
            case SelectedApexMech.none:
                return this.handleNoSelectedApex();
        }
    }

    private handleNoSelectedApex(): void { //todo
        this.position.set(0, 0, 0);
    }

    private handleFemurApex(femur: MechanicalAxisFemurAP | MechanicalAxisFemurLT): void {
        this.position.copy(femur.FH.position);
    }

    private handleTibiaApex(tibia: MechanicalAxisTibiaAP | MechanicalAxisTibiaLT): void {
        if (tibia instanceof MechanicalAxisTibiaAP) {
            this.position.copy(tibia.CP.position).lerp(tibia.CA.position, 0.5);
        } else {
            this.position.copy(tibia.FP.position).lerp(tibia.MA.position, 0.5);
        }
    }

    public reset(): void {
        this.position.set(0, 0, 0);
    }
}
